import { render, staticRenderFns } from "./ReportesLectorPatrocinadores.vue?vue&type=template&id=7fdd383e&"
import script from "./ReportesLectorPatrocinadores.vue?vue&type=script&lang=js&"
export * from "./ReportesLectorPatrocinadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports